//ALL REACT
import * as React from "react";
//MUI COMPONENTS
import {
  Typography,
  TextField,
  Button,
  FormControl,
  Select,
  MenuItem,
  InputLabel
} from "@mui/material";
//MUI ICONS
import { Queue } from "@mui/icons-material";
//STYLES
import styles from "../../../module_css/formsCatalogs.module.css";
//PICTURES
import imgAdd from "../../../assets/svg/add.svg";
//API CONTROLLER
import ApiController from "../../../controllers/api";
//CUSTOM COMPONENTS
import CustomBackdrop from "../../CustomBackdrop";
//OTHERS
import Swal from "sweetalert2";

const ERROR_MESSAGES = {
  required: "EL CAMPO ES OBLIGATORIO",
  invalid: "EL VALOR DEL CAMPO NO CUMPLE CON EL FORMATO",
  minLength: "EL VALOR DEL CAMPO ES DEMASIADO CORTO",
  maxLength: "EL VALOR DEL CAMPO ES DEMASIADO LARGO",
};
const PROPERTIES_ENTRIES = {
  partida: {
    required: true,
    pattern: /^[1-9]\d*$/
  },
  descripcion: {
    required: true,
    pattern: /^[A-ZÁÉÍÓÚÜÑ0-9\s.'"-]+$/,
    minLength: 5,
    maxLength: 100,
  },
  claveBien:{
    required: true,
    pattern: /^(?!0+$)\d+$/,
    minLength: 3,
    maxLength: 3
  }
};

export default function FormCreateProperty({ handleClose, refreshArea }) {
  const [openBackdrop, setOpenBackdrop] = React.useState(false);
  const [getData, setGetData] = React.useState([]);
  const [data, setData] = React.useState({
    partida: "",
    descripcion: "",
    claveBien: null
  });
  const [errors, setErrors] = React.useState({
    partida: [],
    descripcion: [],
    claveBien: []
  });
  const apiInstance = React.useMemo(
    () => new ApiController(process.env.REACT_APP_API_URL),
    []
  );

  const createData = async (data) => await apiInstance.post("/property", data);
  const nextValue = async (partida) => await apiInstance.get(`/property/next-value?partida=${partida}`);
  const getConstantsValues = async () =>
    await apiInstance.get("/property/constants");
  React.useEffect(() => {
    (async () => {
      setOpenBackdrop(true);
      const response = await getConstantsValues();
      if (response.success) {
        setGetData(response.data);
      } else if (!response.success) {
        Swal.fire({
          title: "¡ERROR! ❌",
          icon: "error",
          text: "NO SE PUDIERON CARGAR LOS DATOS",
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          confirmButtonColor: "#ef7474",
          confirmButtonText: "CONFIRMAR",
          padding: "0 0 20px",
        });
        handleClose();
      }
      setOpenBackdrop(false);
    })();
  }, []);

  const handleChange = async (e) => {
    const { name, value } = e.target;
    if(!['claveBien'].includes(name)){
      setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  if (name === "partida" && value) {
    setOpenBackdrop(true);
    const res = await nextValue(value);
    if (res.success){
      setData((prev)=>({
        ...prev,
        claveBien: res.data.nextValue
      }));
    } else {
      Swal.fire({
        title: "¡ERROR! ❌",
        icon: "error",
        text: "NO SE PUDO OBTENER EL SIGUIENTE VALOR PARA ESTA PARTIDA",
        confirmButtonColor: "#ef7474",
      });
      setData((prev)=>({
        ...prev,
        claveBien: null
      }));
    }
    setOpenBackdrop(false);
  }
  };
  const validateFieldGeneric = (value, options = {}) => {
    const errors = [];
    if (options.required && !value) errors.push({ type: "required" });
    if (value && options.pattern && !options.pattern.test(value))
      errors.push({ type: "invalid" });
    if (value && options.minLength && value.length < options.minLength)
      errors.push({ type: "minLength" });
    if (value && options.maxLength && value.length > options.maxLength)
      errors.push({ type: "maxLength" });
    return errors;
  };
  const validateAllFields = () => {
    const newErrors = {};
    for (const field in PROPERTIES_ENTRIES) {
      newErrors[field] = validateFieldGeneric(
        data[field],
        PROPERTIES_ENTRIES[field]
      );
    }
    setErrors(newErrors);
    return !Object.values(newErrors).some(
      (fieldErrors) => fieldErrors.length > 0
    );
  };

  const getHelperText = (field) => {
    return (
      errors[field].map((e) => "- *" + ERROR_MESSAGES[e.type]).join("\n") || ""
    );
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!validateAllFields()) return;
    const sentData = {
      PARTIDA: data.partida,
      CODIGO: data.claveBien,
      DESCRIPCION: data.descripcion.toUpperCase(),
    };
    Swal.fire({
      title: "AGREGAR BIEN ⚠️",
      text: "¿ESTAS SEGURO DE AGREGAR ESTE NUEVO BIEN?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "SI, AGREGAR",
      confirmButtonColor: "#397e32",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setOpenBackdrop(true);
        const res = await createData(sentData);
        if (res.success) {
          Swal.mixin({
            toast: true,
            position: "bottom-start",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          }).fire({
            icon: "success",
            title: "BIEN AGREGADO",
            text: "SE AGREGO CORRECTAMENTE",
          });
          handleClose();
          if (refreshArea) refreshArea();
        } else if (!res.success && res.meta.conflictDuplicate) {
          Swal.fire({
            title: "DATOS DUPLICADOS ⚠️",
            icon: "info",
            html: `<p>ESTOS CAMPOS YA SE ENCUENTRAN REGISTRADOS DENTRO DE LA BASE DE DATOS:</p>
                      ${res.meta.fields.map((f) => `<li>${f}</li>`).join("")}`,
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonColor: "#ef7474",
            confirmButtonText: "CONFIRMAR",
            padding: "0 0 20px",
          });
        } else if (!res.success) {
          Swal.fire({
            title: "¡ERROR! ❌",
            icon: "error",
            text: "NO SE PUDO AGREGAR EL NUEVO BIEN",
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonColor: "#ef7474",
            confirmButtonText: "CONFIRMAR",
            padding: "0 0 20px",
          });
        }
        handleClose();
        setOpenBackdrop(false);
      }
    });
  };
  return (
    <>
      <CustomBackdrop open={openBackdrop} />
      <form className={styles.container_main_form} onSubmit={handleSubmit}>
        <img src={imgAdd} alt="Logo" className={styles.logo_form} />
        <Typography variant="h6" align="center" gutterBottom>
          AGREGAR NUEVO TIPO DE BIEN
        </Typography>
        <FormControl
        variant="outlined"
        sx={{ mt: 1, mb: 1 }}
        fullWidth
        error={errors.partida.length > 0}
        >
        <InputLabel id="partida-label">DESIGNAR PARTIDA</InputLabel>
        <Select
          labelId="partida-label"
          id="partida-select"
          name="partida"
          value={data.partida}
          onChange={handleChange}
          label="DESIGNAR PARTIDA"
        >
          {(getData || []).map((partida) => (
            <MenuItem key={partida.UUID} value={partida.VALUE}>
              {partida.NOMBRE}
            </MenuItem>
          ))}
        </Select>
        {errors.partida.length > 0 && (
          <Typography
            variant="caption"
            color="error"
            sx={{ mt: 0.5, display: "block" }}
          >
            {errors.partida.map((e) => "- *" + ERROR_MESSAGES[e.type]).join("\n")}
          </Typography>
        )}
      </FormControl>

        <TextField
          label="CLAVE DEL BIEN"
          variant="outlined"
          autoComplete="off"
          fullWidth
          className={styles.textField_form}
          name="claveBien"
          value={data.claveBien}
          disabled="true"
          InputLabelProps={{ shrink: true }}
          error={errors.claveBien.length > 0}
          helperText="-ESTE VALOR SE DESIGNA DE FORMA AUTÓMATICA POR EL SISTEMA, DEPENDIENDO DE LA PARTIDA SELECCIONADA"
        />

        <TextField
          label="DESCRIPCIÓN DEL BIEN"
          multiline
          rows={2}
          variant="outlined"
          autoComplete="off"
          fullWidth
          className={styles.textField_form}
          name="descripcion"
          value={data.descripcion}
          onChange={handleChange}
          error={errors.descripcion.length > 0}
          helperText={getHelperText("descripcion")}
          sx={{
            "& .MuiFormHelperText-root": {
              whiteSpace: "pre-line",
            },
          }}
        />
        <Button
          variant="contained"
          size="large"
          startIcon={<Queue />}
          className={styles.button_form}
          type="submit"
          fullWidth
          color="success"
        >
          AGREGAR
        </Button>
      </form>
    </>
  );
}